module.exports = __webpack_public_path__ + "img/AdobeStock_289101851.f98db573.jpeg";